import { FieldValues, RegisterOptions } from 'react-hook-form';

import { t } from '@gem/modules/i18n';

import { TValidationParams } from './validation.types';

export function minLengthValidation<TFieldValues extends FieldValues = FieldValues>(
  minLength: number,
  message?: string,
  params?: TValidationParams
): RegisterOptions<TFieldValues> {
  if (params?.isDisabled) {
    return {};
  }
  const defaultMessage = t('common_min_length_error', { 0: minLength });
  return {
    minLength: {
      value: minLength,
      message: message ?? defaultMessage,
    },
  };
}
